import { WMCodesLookupLayout } from "../../../../common/lookups/Layouts/WMLayouts";

// WM Item Kit Data Profile (Delphi WMD0103). Each user-defined code is a WMCODES descriptive-code
// lookup restricted to its own code type — the CodeType values on edtUSERDEFINEDCODE_1..5 in
// uWMD0103.dfm. They are separate lists, not one shared one.
const code1Layout = WMCodesLookupLayout({ codeType: 'C1' });
const code2Layout = WMCodesLookupLayout({ codeType: 'C2' });
const code3Layout = WMCodesLookupLayout({ codeType: 'C3' });
const code4Layout = WMCodesLookupLayout({ codeType: 'C4' });
const code5Layout = WMCodesLookupLayout({ codeType: 'C5' });

// Add / Edit form. Mirrors the Delphi Primary tab: the profile block on the left, the User Defined
// Codes block on the right.
export const PrimaryLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RecordNumber",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Record #",
                "type": "text",
                "required": false,
                "disabled": true,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ProfileCode",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Profile",
                "type": "text",
                "required": true,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Description",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                // Long text renders multiline (rule 9) — the Delphi Comment is a memo field.
                "name": "Comment",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Comment",
                "type": "textarea",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
    {
        "groupId": 2,
        "label": "User Defined Codes",
        "fields": [
            {
                "name": "Code1",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Code 1",
                "type": "lookup",
                "layout": code1Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Code2",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Code 2",
                "type": "lookup",
                "layout": code2Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Code3",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Code 3",
                "type": "lookup",
                "layout": code3Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Code4",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Code 4",
                "type": "lookup",
                "layout": code4Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Code5",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Code 5",
                "type": "lookup",
                "layout": code5Layout,
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
        ],
    },
];

// Find-screen search panel. Profile and Description search on partial text; the codes match exactly
// through the same lookups the form uses, so a user picks from the real list rather than typing.
//
// Spread across four groups because the dynamic form renders one group per column — a single group
// stacks all seven criteria into one tall column. Same shape as the IM Transaction Entry search
// panel (im/itemManagement/transactionsTab/TransactionsFormLayout.js).
const searchCode = (n, layout) => ({
    "name": `Code${n}`,
    "tableName": "IMITEMKITTHEADERDP",
    "label": `Code ${n}`,
    "type": "lookup",
    "layout": layout,
    "required": false,
    "visible": true,
    "isLabelChanged": false,
});

const audit = (name, label, type) => ({
    name,
    tableName: "IMITEMKITTHEADERDP",
    label,
    type,
    required: false,
    visible: true,
    isLabelChanged: false,
});

export const SearchLayout = [
    {
        "groupId": 1,
        "label": "",
        "fields": [
            {
                "name": "RecordNumber",
                "localizedField": "KEYSEQUENCE",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Record #",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "ProfileCode",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Profile",
                "type": "text",
                "required": false,
                "maxLength": 10,
                "visible": true,
                "isLabelChanged": false,
            },
            {
                "name": "Description",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Description",
                "type": "text",
                "required": false,
                "maxLength": 40,
                "visible": true,
                "isLabelChanged": false,
            },
            audit("LastUpdateDateTo", "Last Updated To", "date"),

        ],
    },
    {
        "groupId": 2,
        "label": "",
        "fields": [
            searchCode(1, code1Layout),
            searchCode(2, code2Layout),
            audit("LastUpdateDateFrom", "Last Updated From", "date"),
            audit("LastUpdateUserId", "Last Updated By", "text"),


        ],
    },
    {
        "groupId": 3,
        "label": "",
        "fields": [
            searchCode(3, code3Layout),
            searchCode(4, code4Layout),
            audit("CreationUserId", "Created By", "text"),

        ],
    },
    {
        "groupId": 4,
        "label": "",
        "fields": [
            searchCode(5, code5Layout),
            {
                "name": "Comment",
                "tableName": "IMITEMKITTHEADERDP",
                "label": "Comment",
                "type": "text",
                "required": false,
                "visible": true,
                "isLabelChanged": false,
            },
            audit("CreationDateTo", "Creation Date To", "date"),
            audit("CreationDateFrom", "Creation Date From", "date"),

        ],
    },
    // Audit criteria. Dates are From/To pairs; the user ids are partial matches.
    
];
